var _rect, _circle, _circle2, _rect2, _path, _path2, _rect3, _rect4, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNefrologia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 280,
    viewBox: "0 0 480 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 480,
    height: 280,
    rx: 24,
    fill: "#EEFDF4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 206,
    r: 44,
    fill: "#DCFCE7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 390,
    cy: 76,
    r: 36,
    fill: "#BBF7D0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 40,
    width: 252,
    height: 196,
    rx: 22,
    fill: "white",
    stroke: "#86EFAC",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176 78C176 62 188 50 204 50C220 50 232 62 232 78V94H176V78Z",
    fill: "#4ADE80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M250 78C250 62 262 50 278 50C294 50 306 62 306 78V94H250V78Z",
    fill: "#22C55E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 104,
    width: 156,
    height: 78,
    rx: 12,
    fill: "#DCFCE7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 190,
    width: 126,
    height: 14,
    rx: 7,
    fill: "#BBF7D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M198 143H286",
    stroke: "#16A34A",
    strokeWidth: 6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNefrologia);
export default __webpack_public_path__ + "static/media/nefrologia.0ad198f5d55a5b39d0db70962f4a1782.svg";
export { ForwardRef as ReactComponent };